<script>
import { Bar as BarChartInstance } from "vue-chartjs";

export default {
  name: "BarChart",
  extends: BarChartInstance,
  props: {
    type: {
      type: String,
      default: "single"
    },
    data: {
      type: Object,
      default: () => {
        return {
          labels: [],
          dataset: []
        }
      }
    },
    stacked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartData() {
      let { labels, dataset } = this.data;
      let computedDataset = [];

      switch (this.type) {
        case "single":
          computedDataset = [
            {
              label: dataset[0].label,
              backgroundColor: "rgb(255, 157, 0)",
              borderRadius: 8,
              data: dataset[0].data
            }
          ];
          break;
        case "fraction":
          computedDataset = [
            {
              label: dataset[0].label,
              backgroundColor: "rgb(255, 157, 0)",
              data: dataset[0].data
            },
            {
              label: dataset[1].label,
              backgroundColor: "rgba(121, 139, 131, 0.1)",
              data: dataset[1].data.map((x, i) => {
                return Math.abs(x - dataset[0].data[i]);
              })
            }
          ];
          break;
        case "multiple":
          dataset.forEach(entry => {
            computedDataset.push({
              label: entry.label,
              backgroundColor: entry.backgroundColor || "rgb(255, 157, 0)",
              data: entry.data,
              borderRadius: 8,
            });
          });
          break;
        default:
          computedDataset = [
            {
              label: dataset[0].label,
              backgroundColor: "rgb(255, 157, 0)",
              data: dataset[0].data
            }
          ];
          break;
      }
      return {
        labels,
        datasets: computedDataset
      };
    },
    setStep() {
      return (
        Math.round(Math.max(...this.chartData.datasets[0].data) / 4 / 10) * 10
      );
    },
    chartOptions() {
      return {
        responsive: true,
        legend: false,
        maintainAspectRatio: false,
        barValueSpacing: 10,
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: true
              },
              stacked: this.stacked,
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                display: true
              },
              stacked: this.stacked,
              ticks: {
                beginAtZero: true,
                // stepSize: this.setStep
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || "";
              let value;
              if (tooltipItem.datasetIndex === 1 && this.type === "fraction") {
                value =
                  tooltipItem.yLabel + data.datasets[0].data[tooltipItem.index];
              } else {
                value = tooltipItem.value;
              }
              if (label) {
                label += ": ";
              }
              label += value;
              return label;
            }
          }
        },
        layout: {
          padding: {
            top: 10
          }
        },
        plugins: {
          datalabels: {
            color: '#000',
            textAlign: "center",
            font: {
              weight: "bold",
              color: '#000',
              size: 12
            },
            formatter: (value) => {
              return this.$numeral(value).format('0,0')
            }
          }
        }
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.chartOptions);
      },
      deep: true
      // // this.$data._chart.update();
    }
  }
};
</script>

<style lang="scss" scoped></style>
